import {
  Component,
  ElementRef,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { UiSize } from '../../common-interface';
import { UiInputValueType } from '../input';
import { NgClass, NgIf } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormControl } from '@app-utils';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';

/**
 * Password component
 */
@Component({
  selector: 'ui-password',
  templateUrl: './password.component.html',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PasswordComponent,
    },
  ],
  imports: [FormsModule, NgClass, PasswordModule, DividerModule, NgIf],
})
export class PasswordComponent extends BaseFormControl<UiInputValueType> {
  @ViewChild('input', { static: true }) input!: ElementRef;

  @Input() name = '';

  @Input() inputId?: string;

  @Input() hasError = false;

  @Input() toggleMask = true;

  @Input() feedback = true;

  @Input() override isDisabled = false;

  @Input() ariaLabel?: string;

  @Input() ariaLabelledBy?: string;

  @Input() addClass: string | string[] | Record<string, boolean> = '';

  @Input() size: UiSize = 'medium';

  @Input() maxlength: number | string | null = null;

  @Input() minlength: number | string | null = null;

  @Input() placeholder = '';

  @Output() inputKeyPress = new EventEmitter<Event>();
}
